module.exports = __webpack_public_path__ + "static/media/code-of-conduct.8fcdba20.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/security/code-of-conduct.pdf
// module id = 542
// module chunks = 0